/**
 * Created by huzhongchun on 2018/4/9.
 */
import Axios from 'axios';
import util from '../util/util';

const baseURL = (process.env.NODE_ENV === 'development') ? '/api' : util.getOnlineApiHost();
const APP_ID = document.getElementById('hidden-appid-value') ? document.getElementById('hidden-appid-value').value : '';
const UA = document.getElementById('hidden-X_THEFAIR_UA-value') ? document.getElementById('hidden-X_THEFAIR_UA-value').value : '';
const AUTH = document.getElementById('hidden-X_THEFAIR_AUTH-value') ? document.getElementById('hidden-X_THEFAIR_AUTH-value').value : '';
const SOURCE = document.getElementById('hidden-source-value') ? document.getElementById('hidden-source-value').value : '';
const HASHID = document.getElementById('hidden-hashid-value') ? document.getElementById('hidden-hashid-value').value : '';
const UID = document.getElementById('hidden-uid-value') ? document.getElementById('hidden-uid-value').value : '';

//@todo 以后增加本地登录逻辑
let appid = (process.env.NODE_ENV === 'development') ? util.getAppId() : APP_ID;
const axiosConfig = {
	headers: {
		'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
		'X_THEFAIR_UA': UA,
		'X_THEFAIR_AUTH': AUTH,
	},
	transformRequest: [function (data) {
		if(typeof data === 'string'){
			return data;
		}else{
			let retArray = [];
			for (let it in data) {
				let item = data[it];
				if (typeof item === 'object') {
					item = JSON.stringify(data[it]);
				}
				retArray.push(encodeURIComponent(it) + '=' + encodeURIComponent(item));
			}
			return retArray.join('&');
		}
	}],
	timeout: 10000,
	baseURL,
	withCredentials: true, //cors请求允许发送cookie
	responseType: 'json',
	retry: 1,
	retryDelay: 200
};

const instance = Axios.create(axiosConfig);

//增加错误的重试
instance.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
	let config = err.config;
	// If config does not exist or the retry option is not set, reject
	if(!config || !config.retry) return Promise.reject(err);

	// Set the variable for keeping track of the retry count
	config.__retryCount = config.__retryCount || 0;

	// Check if we've maxed out the total number of retries
	if(config.__retryCount >= config.retry) {
		// Reject with the error
		return Promise.reject(err);
	}

	//业务异常不重试
	if(err.response && err.response.data && [40000,60000,31501,31502,40001,40005].includes(Number(err.response.data.code))){
		return Promise.reject(err);
	}

	// Increase the retry count
	config.__retryCount += 1;

	// Create new promise to handle exponential backoff
	let backoff = new Promise(function(resolve) {
		setTimeout(function() {
			resolve();
		}, config.retryDelay || 1);
	});

	//此时的url已经拼接上之前的baseURL，需要baseURL置空，否则会重复
	config.baseURL = '';
	// Return the promise in which recalls axios to retry the request
	return backoff.then(function() {
		return Axios(config);
	});
});


//添加所有请求的默认信息
let appendAutoData = (options) => {
	//增加appid
	let data = options.data || {};
	let defaultData = {
		appid: appid
	};
	if (SOURCE) {
		defaultData['__s'] = SOURCE;
	}
	SOURCE && (defaultData['__s'] = SOURCE);
	HASHID && (defaultData['hashid'] = HASHID);
	data = Object.assign({}, defaultData, data);
	options['data'] = data;
	//增加时间戳 @Todo 由于时间戳的更新每个请求的url不一样，会导致options的缓存不生效的问题，
	// let url = options.url;
	// url = url + (url.match(/\?/) ? '&' : '?') + '_ajax_stamp_=' + (+new Date());
	// options['url'] = url;
	return options;
};

let reloadPageing = false;
let reloadPageCount = 0;
let errorHandle = (res, options, type, resolve, reject) => {
	if(res.response && res.response.config) delete res.response.config;
	if(res.config) delete res.config;
	try {
		let responseData = '';
		if (res.response) {
			if(typeof res.response === 'object')
				responseData = res.response.data;
			else if(typeof res.response === 'string'){
				alert(res.response);
				reject && reject(res);
				return false;
			}
		}else{
			if (Error.isError(res)) {
				// alert(res.message);
			}
			reject && reject(res);
			return false;
		}
		if (responseData && Number(responseData.code) === 40000) {
			alert('登录失败');
			//需要登录
			// util.redirectTo('/login');
			//@Todo  安卓客户端兼容第一次加载页面就请求接口，会导致接口返回40000的问题
			if (util.parseUA().app && !reloadPageing && reloadPageCount <= 5) {
				// window.location.href = 'taooweb://refreshWebView';
				reloadPageing = true;
				reloadPageCount++;
				setTimeout(() => {
					window.location.reload();
				}, 1000);
			}
			if (reloadPageCount > 5) {
				alert('Error：request 79');
			}
		} else if (responseData && Number(responseData.code) === 60000) {
			// alert(60000);
			//auth过期 @todo 需要处理多个接口同时60000多次refreshAuth的问题
			refreshAuth(options, type, resolve, reject);
		} else if (responseData && Number(responseData.code) === 31501) {
			//判断是否购买过课程的特殊code做重定向
			util.redirectTo('/entrance');
		} else if (responseData && Number(responseData.code) === 31502) {
			//判断是否走完入学流程
			util.redirectTo('/study');
		} else if (responseData && Number(responseData.code) === 30902) {
			// 晚安短信错误处理
			reject && reject('30902');
		}
		// else if(responseData && Number(responseData.code) === 40005) {
		// 	window.location.href = '/v1/user/logout?t=' + Date.now();
		// 	// util.redirectTo('/v1/user/logout?t=' + Date.now());
		// }
		else{
			if (!options.closeAutoErrorAlert && responseData && responseData.message) {
				// if(responseData.message.text === 'W订单交易号生成失败') {
				// 	alert('点确认刷新页面');
				// 	window.location.href = 'https://h5.taooo.cc/v1/user/logout';
				// } else {
					alert(responseData.message.text);
				// }
			}
			reject && reject(res);
		}
	} catch (e) {
		reject && reject(e);
	}
};


//返回新的Promise，拿到resolve和reject，以便在refreshToken之后，触发resolve和reject
let post = (options) => {
	let startTime = +new Date();
	return new Promise((resolve, reject) => {
		instance.request(Object.assign({
			method: 'post'
		}, appendAutoData(options))).then((res) => {
			resolve && resolve(res.data);
		}).catch((res) => {
			if (Error.isError(res)) {
				//忽略业务逻辑的code
				if(res.response && res.response.data && res.response.data.code && [31501,31502,40000].includes(res.response.data.code)){

				}else{
					util.addEventGa(process.env.PROJECT_LABEL,'UID：'+String(UID),window.location.protocol+options.url+'-e-'+(+new Date() - startTime)+'-'+res.message);
				}
			}
			errorHandle(res, options, 'post', resolve, reject);
		});
	});
};

let get = (options) => {
	let startTime = +new Date();
	return new Promise((resolve, reject) => {
		instance.request(Object.assign({
			method: 'get'
		}, appendAutoData(options))).then((res) => {
			resolve && resolve(res.data);
		}).catch((res) => {
			//忽略业务逻辑的code
			if(res.response && res.response.data && res.response.data.code && [31501,31502].includes(res.response.data.code)){

			}else{
				util.addEventGa(process.env.PROJECT_LABEL,'UID：'+String(UID),window.location.protocol+options.url+'-e-'+(+new Date() - startTime)+'-'+res.message);
			}
			errorHandle(res, options, 'get', resolve, reject);
		});
	});
};

let refreshAuthCount = 0; //刷新token超过5次了 不再请求

let refreshAuth = (options, type, resolve, reject) => {
	if (refreshAuthCount <= 5) {
		refreshAuthCount++;
		Axios.request({
			url: util.getGetTokenUrl(),
			method: 'post',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
				'X_THEFAIR_UA': UA,
				'X_THEFAIR_AUTH': AUTH,
			},
			data: {
				'grant_type': 'get_token'
			},
			transformRequest: [function (data) {
				let retArray = [];
				for (let it in data) {
					retArray.push(encodeURIComponent(it) + '=' + encodeURIComponent(data[it]));
				}
				return retArray.join('&');
			}]
		}).then((res) => {
			instance.defaults.headers['X_THEFAIR_AUTH'] = res.data.result.x_thefair_auth;
			if (type === 'post') {
				post(options).then((res) => {
					resolve && resolve(res);
				}).catch((res) => {
					alert('接口请求异常，请刷新页面重试！');
				});
			} else if (type === 'get') {
				get(options).then((res) => {
					resolve && resolve(res);
				}).catch((res) => {
					alert('接口请求异常，请刷新页面重试！');
				});
			}
		}).catch((res) => {
			alert('Get token failed!');
			console.log(res);
		});
	} else {
		alert('refreshAuth失败，请联系客服');
	}
};

export default {
	post,
	get
};



// WEBPACK FOOTER //
// ./src/api/request.js